import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-6 sm:py-8 md:py-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand Section */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-2 sm:mb-3">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-blue-600 to-blue-500 rounded-lg flex items-center justify-center shadow-lg">
                <Search className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
              </div>
              <span className="text-base sm:text-lg lg:text-xl font-bold text-white">Lost & Found</span>
            </Link>
            <p className="text-[10px] sm:text-xs lg:text-sm text-gray-400 mb-3 sm:mb-4 leading-relaxed max-w-xs">
              Helping people reconnect with their lost belongings through community support.
            </p>
            {/* Social Links */}
            <div className="flex space-x-2 sm:space-x-3">
              <a
                href="#"
                className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800/50 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-all hover:scale-110 backdrop-blur-sm"
                aria-label="Facebook"
              >
                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="#"
                className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800/50 hover:bg-blue-400 rounded-lg flex items-center justify-center transition-all hover:scale-110 backdrop-blur-sm"
                aria-label="Twitter"
              >
                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a
                href="#"
                className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-800/50 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-all hover:scale-110 backdrop-blur-sm"
                aria-label="Instagram"
              >
                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3 text-white">Quick Links</h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <a href="/items" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Browse Items
                </a>
              </li>
              <li>
                <a href="/report-lost" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Report Lost Item
                </a>
              </li>
              <li>
                <a href="/report-found" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Report Found Item
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3 text-white">Support</h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3 text-white">Legal</h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700/50 mt-4 sm:mt-6 lg:mt-8 pt-3 sm:pt-5 lg:pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <p className="text-[10px] sm:text-xs text-gray-400 text-center sm:text-left">
              © {currentYear} Lost & Found. All rights reserved.
            </p>
            <p className="text-[10px] sm:text-xs text-gray-500 flex items-center">
              Made with <Heart className="w-2.5 h-2.5 sm:w-3 sm:h-3 mx-1 text-red-500 fill-current" /> by Priyesh Singh
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;